import { render, staticRenderFns } from "./LabelCompaniesEditPanelDialog.vue?vue&type=template&id=6e7a2c5a&scoped=true"
import script from "./LabelCompaniesEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./LabelCompaniesEditPanelDialog.vue?vue&type=script&lang=js"
import style0 from "./LabelCompaniesEditPanelDialog.vue?vue&type=style&index=0&id=6e7a2c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7a2c5a",
  null
  
)

export default component.exports